import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { flatMap } from 'rxjs/operators';

import { Restaurant } from '../../models/restaurant.model';
import { RestaurantService } from '../../services/restaurant.service';
import { Utils } from '../../shared/util';
import { V2TopBarOptions } from '../../shared/components/v2/v2-top-bar/v2-top-bar.component';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.page.html',
  styleUrls: ['./rating.page.scss'],
})
export class RatingPage implements OnInit {

  public rating: number = 0
  public suggestion: string = ''
  public name: string
  public phone: string

  constructor(
    private restaurantService: RestaurantService,
    private router: Router,
    private utils: Utils,
  ) { }

  ngOnInit() {
  }

  /**
   * Zera os campos ao entrar na página
   */
  ionViewDidEnter() {
    this.suggestion = ''
    this.name = ''
    this.phone = ''
    this.rating = 0
  }

  /**
   * Avalia o restaurante
   */
  rate() {
    this.utils.setStateLoading(true);
    this.restaurantService.getRest().pipe(
      flatMap(rest => this.restaurantService.rate({
        value: this.rating,
        restauranteId: rest.restauranteId,
        suggestion: this.suggestion,
        name: this.name,
        phone: this.phone
      }))
    ).subscribe({
      next: () => {
        this.suggestion = ''
        this.name = ''
        this.phone = ''
        this.rating = 0
        this.utils.setStateLoading(false)
        this.utils.showToast({ message: 'Obrigado! Sua opinião conta muito!' })
        this.router.navigate([environment.routePaths.v2.version, environment.routePaths.v2.home])
      },
      error: err => {
        this.utils.setStateLoading(false)
        this.utils.showToast(err)
      },
    })
  }
}
